module.exports = new __parcel__URL__("add_points_button.4110e346.png").toString();